"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CommandsManager_1 = __importDefault(require("../general/CommandsManager"));
// File containing everything regarding recording from MediaStreams
// and showing recordings as waveforms
const workerOptions = {
    OggOpusEncoderWasmPath: "js/OggOpusEncoder.wasm",
    WebMOpusEncoderWasmPath: "js/WebMOpusEncoder.wasm",
};
const EVENTS = {
    uploadingRecording: "uploadingRecording",
    errorUploading: "errorUploading",
    finishUpload: "finish_upload",
};
class AudioRecorder {
    constructor(publisher) {
        this.recordedBlobs = [];
        this.isRecording = false;
        this.recordings = [];
        this.doneUploading = 0;
        this.recordingName = "Recording";
        this.publisher = publisher;
        CommandsManager_1.default
            .registerNewCommand("anywhere--start_recording", this.start.bind(this))
            .registerNewCommand("anywhere--stop_recording", this.stop.bind(this))
            .registerNewCommand("anywhere--start_upload", this.uploadAllRecordings.bind(this))
            .registerNewCommand("anywhere--set_recording_name", (data) => {
            const recordingNameMessage = data.args.message;
            this.setRecordingName(recordingNameMessage);
        });
        document.onkeydown = (e) => {
            var _a, _b;
            // if its writing in any input or textarea disable this listener
            if (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.tagName) === 'INPUT')
                return;
            if (((_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.tagName) === 'TEXTAREA')
                return;
            if (e.ctrlKey && e.key === 'd') {
                this.downloadAllRecordings();
            }
        };
    }
    handleDataAvailable(event) {
        if (event.data && event.data.size > 0) {
            this.recordedBlobs.push(event.data);
        }
    }
    start() {
        var _a;
        const wavOptions = "audio/wav";
        this.recordedBlobs = [];
        this.isRecording = true;
        (_a = this.mediaRecorder) === null || _a === void 0 ? void 0 : _a.start(10000000);
        let isRecordingSign = document.querySelector("#isRecording");
        if (isRecordingSign) {
            isRecordingSign.classList.remove("hidden");
        }
        this.isRecording = true;
        this.publisher("updateSessionInfo", { isRecording: this.isRecording });
    }
    stop() {
        var _a;
        console.log("Stopping recording");
        this.isRecording = false;
        this.publisher("updateSessionInfo", { isRecording: this.isRecording });
        (_a = this.mediaRecorder) === null || _a === void 0 ? void 0 : _a.stop();
        this.publisher("stopped_recording");
        let isRecordingSign = document.querySelector("#isRecording");
        if (isRecordingSign) {
            isRecordingSign.classList.add("hidden");
        }
    }
    getBlobs() {
        return this.recordedBlobs;
    }
    uploadAllRecordings() {
        for (let i = 0; i < this.recordings.length; i++) {
            const index = i;
            window.setTimeout(() => {
                this.uploadRecording(index);
            }, 1000 * i);
        }
    }
    setRecordingStream(stream) {
        this.recordingStream = stream;
        console.log("audio recording setting opus media recorder");
        let AudioMediaRecorder = OpusMediaRecorder;
        // OPUS LARGEST bitrate 128kbps in chrome (audio/webm;codecs=opus)
        const nativeChrome = "audio/webm;codecs=opus";
        const wavOptions = "audio/wav";
        let options = { mimeType: wavOptions, audioBitsPerSecond: 2580000 };
        const errorMsgElement = document.querySelector('span#errorMsg');
        if (!AudioMediaRecorder.isTypeSupported(options.mimeType)) {
            console.error(`${options.mimeType} is not Supported`);
            errorMsgElement.innerHTML = `${options.mimeType} is not Supported`;
            options = { mimeType: "audio/mp4" };
            // options = {mimeType: 'video/webm;codecs=vp8'};
            if (!AudioMediaRecorder.isTypeSupported(options.mimeType)) {
                console.error(`${options.mimeType} is not Supported`);
                errorMsgElement.innerHTML = `${options.mimeType} is not Supported`;
                options = { mimeType: "video/webm" };
                if (!AudioMediaRecorder.isTypeSupported(options.mimeType)) {
                    console.error(`${options.mimeType} is not Supported`);
                    errorMsgElement.innerHTML = `${options.mimeType} is not Supported`;
                    options = { mimeType: "" };
                }
            }
        }
        try {
            this.mediaRecorder = new AudioMediaRecorder(this.recordingStream, options);
            this.mediaRecorder.ondataavailable = this.handleDataAvailable.bind(this);
        }
        catch (e) {
            console.error("Exception while creating AudioMediaRecorder:", e);
            errorMsgElement.innerHTML = `Exception while creating AudioMediaRecorder: ${JSON.stringify(e)}`;
            return;
        }
        if (this.mediaRecorder) {
            this.mediaRecorder.onstop = (event) => {
                // if (recordButton) recordButton.textContent = "Record";
                // processing
                const superBuffer = new Blob(this.recordedBlobs, { type: wavOptions });
                this.recordings.push(superBuffer);
                // download last recording as a backup
                this.downloadRecording(this.recordings.length - 1);
            };
        }
    }
    setRecordingName(name) {
        this.recordingName = name;
    }
    uploadRecording(index) {
        var _a, _b;
        console.log("recording", index, this.recordings[index]);
        let uploadingNow = document.querySelector("#uploadingNow");
        uploadingNow === null || uploadingNow === void 0 ? void 0 : uploadingNow.classList.remove("hidden");
        let name = (_b = (_a = document.querySelector(".userName")) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim();
        if (name == null) {
            name = "host";
        }
        this.publisher(EVENTS.uploadingRecording);
        const fd = new FormData();
        const extension = "wav"; // or "wav"
        let recordingName = `${this.recordingName} - ${name} - ${index + 1}`;
        fd.append("file", this.recordings[index], `${recordingName}.${extension}`);
        fd.append("name", recordingName);
        fd.append("authenticity_token", authenticity_token);
        const xhr = new XMLHttpRequest();
        xhr.open("POST", `/rooms/${room}/upload`, true);
        xhr.onload = function (e) { };
        // Listen to the upload progress.
        // assuming you have a progress element on your dom
        // var progressBar = document.querySelector('progress#upload');
        xhr.upload.onprogress = (e) => {
            // if (e.lengthComputable) {
            //   progressBar.value = (e.loaded / e.total) * 100;
            //   progressBar.textContent = progressBar.value; // Fallback for unsupported browsers.
            // }
            // if(progressBar.value == 1){
            //   // update UI
            //   $("#uploadingNow").addClass("hidden")
            //   $("#doneUploading").removeClass("hidden")
            // }
            if (e.loaded / e.total === 1) {
                this.finishedUpload();
            }
        };
        xhr.upload.onerror = (e) => {
            uploadingNow === null || uploadingNow === void 0 ? void 0 : uploadingNow.classList.add("hidden");
            handleError(`Error ${xhr.status} occurred uploading your file`);
            this.publisher(EVENTS.errorUploading);
        };
        xhr.send(fd);
    }
    // global so its called in ui.js keyboard interceptor.
    downloadAllRecordings() {
        for (let i = 0; i < this.recordings.length; i++) {
            this.downloadRecording(i);
        }
    }
    ;
    downloadRecording(i) {
        const url = window.URL.createObjectURL(this.recordings[i]);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `${this.recordingName} - ${window.name} - ${i + 1}`;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 100);
    }
    finishedUpload() {
        this.doneUploading++;
        if (this.doneUploading == this.recordings.length) {
            this.recordings = [];
            this.doneUploading = 0;
            this.publisher(EVENTS.finishUpload);
        }
    }
}
exports.default = AudioRecorder;
